import { useFeatureFlags } from "hooks/useFeatureFlags";

import { Layout } from "../../components/Layout";
import { StaffOnly } from "../../components/StaffOnly";

export function Staff() {
  const { loading } = useFeatureFlags();
  let content = null;

  if (!loading) {
    content = <Layout />;
  }

  return <StaffOnly>{content}</StaffOnly>;
}
